<template>
  <!-- 原始班级名称 -->
  <a-form-item label="原始班级" class="class-item">
    <a-select
      showSearch
      class="form-cell"
      placeholder="请选择原始班级"
      :filterOption="false"
      @search="searchClass"
      :notFoundContent="searchClassLoading ? undefined : '没有查询结果'"
      v-model="modelClass"
    >
      <a-spin v-if="searchClassLoading" slot="notFoundContent" size="small" />
      <a-select-option v-for="d in classList" :key="d.id">{{
        d.className
      }}</a-select-option>
    </a-select>
  </a-form-item>
</template>
<script>
import sourceClass from "../../api/sourceClass";

export default {
  name: "CClassSelect",
  props: ["classCode"],
  data() {
    return {
      searchClassLoading: false, //搜索原始班级loading
      classList: [], //原始班级list
      modelClass: this.classCode,
    };
  },
  watch: {
    modelClass() {
      this.$emit("update:classCode", this.modelClass);
    },
    classCode() {
      this.modelClass = this.classCode;
    },
  },
  methods: {
    //搜索原始班级
    searchClass(val = "") {
      this.searchClassLoading = true;
      sourceClass.teaOriginalClass({ className: val }).then((res) => {
        this.searchClassLoading = false;
        this.classList = res.data;
      });
    },
  },
  created() {
    this.searchClass();
  },
};
</script>
<style scoped lang="scss">
</style>
